import React, { Component, Fragment } from 'react';
import SectionBlock from './../../../../SectionBlock/SectionBlock';
import { virtualize } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import { swipeView } from './../../../../../../SwipeView/SwipeView';
import Hypher from 'hypher';
import hyphenatePattern from './utils/hyphenatePattern';
import Dropdown from './../../../../../../Dropdown/Dropdown';
import ReportSwipeViewWrapper from './../../../../ReportSwipeViewWrapper/ReportSwipeViewWrapper';
import ScoreDisplayTypes from './../../../../../constants/ScoreDisplayTypes';
import ReportHelper from './../../../../../helpers/ReportHelper';
import ScoreBarTypes from './../../../../../constants/ScoreBarTypes';
import ScoreBarNG from './../../../../../components/ScoreBarNG/ScoreBarNG';

// eslint-disable-next-line css-modules/no-unused-class
import style from './style/personality.scss';

const VirtualizeSwipeableViews = virtualize(SwipeableViews);
const PersonalitySwipeView = swipeView(VirtualizeSwipeableViews);
const selectSubScaleElement = 'selectSubScale';

export default class PersonalityAttachment extends Component {
    constructor(props) {
        super(props);

        this.getSlideContent = this.getSlideContent.bind(this);
        this.handleSwipeChange = this.handleSwipeChange.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.changeSlide = this.changeSlide.bind(this);
        this.findOneScoreByHandle = this.findOneScoreByHandle.bind(this);
        this.findSubScalesByMainScaleHandle = this.findSubScalesByMainScaleHandle.bind(this);

        this.hyphenateText = this.hyphenateText.bind(this);
        this.initHypher = this.initHypher.bind(this);

        this.state = {
            activeStep: 0,
            mainScales: [],
            subScales: [],
            hypher: false
        };

        // default language ID while the actual one is coming in over props
        this.languageId = this.props.defaultLanguage;
    }

    hyphenateText(val) {
        if (!this.state.hypher) {
            return val;
        }

        return val.split(' ').map(value => this.state.hypher.hyphenate(value).join('&shy;')).join(' ');
    }

    initHypher() {

        // load the right hyphenation pattern for the current language and start the hyphenation process
        hyphenatePattern(this.languageId).then(result => {

            // instantiate new Hypher object
            this.setState({ hypher: new Hypher(result) });
        });
    }

    componentDidUpdate() {
        if (this.props.languageId !== this.languageId) {
            this.languageId = this.props.languageId;
            this.initHypher();
        }
    }

    componentDidMount() {
        const { content } = this.props;
        const mainScales = [];

        this.initHypher();

        // build main scales (used for lookup and populating the dropdown)
        content.scores.forEach(score => {
            if (score.scaleType === 'main') {
                mainScales.push(score.handle);
            }
        });

        const subScales = [];

        mainScales.forEach(mainScale => {

            const subScaleArray = [];

            // build sub scales for each mainscale
            content.scores.forEach(score => {
                if (score.parentScale === mainScale) {
                    subScaleArray.push(score);
                }
            });

            subScales.push({
                handle: mainScale,
                scales: subScaleArray
            });
        });

        this.setState({
            mainScales,
            subScales
        });
    }

    getSlideContent(index) {
        const { i18nParticipation } = this.props;
        const scoreData = this.findOneScoreByHandle(this.state.mainScales[index]);

        if (!scoreData) {
            return null;
        }

        return (
            <Fragment key={`slide-${index}`}>
                <ul className={ style.personalityMainScale__wrapper }>
                    <li className={ style.mainScale__item }>
                        { scoreData.lowDefinition }
                    </li>
                    <li className={ style.mainScale__item }>
                        <ScoreBarNG
                            classes={{
                                categoryScore: style.categoryScore,
                                displayScore: style.displayScore,
                                barGraph: {
                                    root: style.barGraph
                                }
                            }}
                            scoreValue={ scoreData.score }
                            displayScore={ scoreData.displayScores ? ReportHelper.getScoreType(scoreData.displayScores, ScoreDisplayTypes.NORM5, 1) : null }
                            scoreBarType={ ScoreBarTypes.BAR_GRAPH }

                        />
                        <ul>
                            <p className={ style.lowLabel }>{ scoreData.lowLabel }</p>
                            <p className={ style.highLabel }>{ scoreData.highLabel }</p>
                        </ul>
                    </li>
                    <li className={ style.mainScale__item }>
                        { scoreData.highDefinition }
                    </li>
                </ul>
                <header className={ style.groupedScoreBlockSection__header }>
                    { `${i18nParticipation.report_score_bar_group_header} ${scoreData.name.toLowerCase()}.` }
                </header>
                { this.findSubScalesByMainScaleHandle(scoreData.handle) }
            </Fragment>
        );
    }

    findOneScoreByHandle(handle) {
        let scoreOutput = null;

        this.props.content.scores.some(score => {
            if (score.handle === handle) {
                scoreOutput = score;
            }

            return scoreOutput;
        });

        return scoreOutput;
    }

    findSubScalesByMainScaleHandle(handle) {
        if (!this.state.subScales.length) {
            return null;
        }

        let subScaleScores = null;

        this.state.subScales.some(subScale => {
            if (subScale.handle === handle) {
                subScaleScores = subScale.scales;
            }

            return subScaleScores;
        });

        const subScaleScoresOutput = [];

        if (subScaleScores) {

            subScaleScores.forEach(subScaleScore => {
                let norm5Score = null;

                if (subScaleScore.displayScores) {
                    norm5Score = ReportHelper.getScoreType(subScaleScore.displayScores, ScoreDisplayTypes.NORM5, 1);
                }

                subScaleScoresOutput.push(
                    <li key={ `${handle}-${subScaleScore.handle}` } className={ style.personalitySubScale__item }>
                        <h3 dangerouslySetInnerHTML={ { __html: this.hyphenateText(subScaleScore.name) } } />
                        <ScoreBarNG
                            classes={{
                                displayScore: style.displayScore,
                                categoryScore: style.categoryScore
                            }}
                            scoreValue={ subScaleScore.score }
                            displayScore={ norm5Score }
                            scoreBarType={ ScoreBarTypes.BAR_GRAPH }
                        />
                        <ul>
                            <p className={ style.lowLabel }>{ subScaleScore.lowLabel }</p>
                            <p className={ style.highLabel }>{ subScaleScore.highLabel }</p>
                        </ul>
                    </li>
                );
            });
        }

        if (subScaleScoresOutput.length) {
            return <ul className={ style.personalitySubScale__wrapper}>{ subScaleScoresOutput }</ul>;
        }

        return null;
    }

    getOptionsForMainScales() {
        const mainScaleOptions = [];

        this.state.mainScales.forEach((mainScale, index) => {
            const scoreEntry = this.findOneScoreByHandle(mainScale);

            mainScaleOptions.push(
                <option
                    value={index}
                    key={`scale_${mainScale}_${index}`}
                >
                    { scoreEntry.name }
                </option>
            );
        });

        return mainScaleOptions;
    }

    handleSwipeChange(activeStep) {
        this.setState({
            activeStep
        });
    }

    handleBack() {
        this.setState({
            activeStep: this.state.activeStep - 1 > -1
                ? this.state.activeStep - 1
                : this.state.mainScales.length - 1
        });
    }

    handleNext() {
        this.setState({
            activeStep: this.state.activeStep + 1 >= this.state.mainScales.length
                ? 0
                : this.state.activeStep + 1
        });
    }

    changeSlide() {
        const element = document.querySelector(`#${selectSubScaleElement}`);
        const selectedSubScale = element.options[element.selectedIndex].value;

        this.setState({
            activeStep: parseInt(selectedSubScale, 0)
        });
    }


    render() {
        const { content, i18nParticipation } = this.props;

        if (!this.state.mainScales.length) {
            return null;
        }

        return <Fragment>
            <div className={ style.personality }>

                { content.definition
                    ? <SectionBlock classes={{ root: style.sectionBlockBlue }}>
                        <p dangerouslySetInnerHTML={{ __html: content.definition }}/>
                    </SectionBlock>
                    : null
                }

                <ul className={ style.personality__titleSectionContainer }>
                    <li className={ style.personalityTitleSectionContainer__side }/>
                    <li>
                        <Dropdown
                            title={ i18nParticipation.report_select_a_scale }
                            id={ selectSubScaleElement }
                            onChange={ this.changeSlide }
                            value={ this.state.activeStep }
                            classes={{
                                root: style.personality__dropdown,
                                optionSelection: style.personality__optionSelection
                            }}
                        >
                            { this.getOptionsForMainScales() }
                        </Dropdown>
                    </li>
                    <li className={ style.personalityTitleSectionContainer__side }/>
                </ul>
                <ReportSwipeViewWrapper
                    handleBack={ this.handleBack }
                    handleNext={ this.handleNext }
                    classes={{ swipeContent: style.personality__swipeContent }}
                >
                    <PersonalitySwipeView
                        getSlideContent={ this.getSlideContent }
                        activeIndex={ this.state.activeStep }
                        slideCount={ this.state.mainScales.length }
                        onChangeIndex={ this.handleSwipeChange.bind(this) }
                        enableMouseEvents
                    />
                </ReportSwipeViewWrapper>
            </div>
        </Fragment>;
    }
}
